<template>
  <v-menu
    overflow-y-scroll
    class="justify-center align-center d-flex"
    location="left top"
    style="z-index: 22222"
  >
    <template #activator="{ props }">
      <v-btn
        :id="buttonId()"
        color="primary"
        v-bind="props"
        variant="outlined"
        :size="$vuetify.display.mobile ? 'small' : 'regular'"
        class="d-inline ml-4 pl-6 pr-4 regionBtn justify-center align-center"
      >
        <span v-if="regionData" :class="regionLayoutClasses()">{{
          regionData.title
        }}</span>
        <span v-if="!regionData" :class="regionLayoutClasses()">{{
          $t("regions.region_select")
        }}</span>
        <v-icon>$mdiChevronDown</v-icon>
      </v-btn>
    </template>

    <v-list
      v-model:selected="selection"
      class="region-list"
      nav
      density="compact"
      one-line
      min-width="500"
    >
      <v-list-subheader>{{ $t("regions.region_plural") }}</v-list-subheader>

      <v-list-item
        v-for="(item, i) in regions"
        :key="`item-${i}`"
        :value="item.id"
        active-class="teal--text text--darken-4"
        :active="regionData.id == item.id"
        rounded="sm"
      >
        <template #prepend>
          <v-icon> $mdiHomeCity </v-icon>
        </template>

        <v-list-item-title
          >{{ item.title }} <v-chip end>{{ item.locations }}</v-chip>
        </v-list-item-title>
        <template #append>
          <v-btn
            v-if="regionData.id != item.id"
            color="grey-lighten-1"
            icon="$mdiChevronRight"
            variant="text"
          ></v-btn>
          <v-btn
            v-if="regionData.id == item.id"
            color="grey-lighten-1"
            icon="$mdiClose"
            variant="text"
            @click.stop="deselect"
          ></v-btn>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script setup>
import { computed, ref, watch } from "vue";
import { useLoaderStore } from "@/stores/loader";
import { useRegionStore } from "@/stores/region";
import { useRegionsStore } from "@/stores/regions";
import { useLocationsStore } from "@/stores/locations";
import { useDisplay } from "vuetify";

const loaderStore = useLoaderStore();

const activeRegion = ref(null);
const selection = ref(null);

const locationsStore = useLocationsStore();
const regionStore = useRegionStore();
const regionsStore = useRegionsStore();
const regionData = computed(() => regionStore.getregionData);
const regionId = computed(() => regionStore.getregionId);
const regions = computed(() => regionsStore.getRegions);

const dprops = defineProps({
  headline: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "regionBtn",
  },
});

const regionLayoutClasses = () => {
  return "d-none d-md-block " + dprops.headline;
};

const buttonId = () => {
  return dprops.id;
};

watch(selection, function (newState, oldState) {
  if (newState != oldState) {
    if (newState[0] != regionId.value) {
      regionStore.fetchRegion(newState[0]).then(() => {
        console.log("resolve region/fetchRegion", regionId.value, newState);
      });
    }
  }
});

const { width, mobile, name } = useDisplay();

// const setActive = function (region) {
//   loaderStore.show();
//   regionStore.fetchRegion(region).then(() => {
//     loaderStore.hide();
//   });
// };
const deselect = function () {
  regionStore.clear().then(() => {
    activeRegion.value = null;
    locationsStore.load();
  });
};
</script>
